<template>
  <ChallengeForm is-new />
</template>

<script>
import ChallengeForm from '../components/ChallengesForm.vue'

export default {
  components: { ChallengeForm },
}
</script>
